import { render, staticRenderFns } from "./SiteAlerts.vue?vue&type=template&id=330f6d2c"
import script from "./SiteAlerts.vue?vue&type=script&lang=js"
export * from "./SiteAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports